import cuid from "cuid";

const ID = '__id';

const normalizeItems = (idKey, items) => {
	return (items || []).map(item => ({
		...item,
		MetroStations: item.MetroStations && item.MetroStations.join('/'),
		[ID]: item[idKey] || cuid(),
	}));
};

const withGeneratedId = () => ({[ID]: cuid()});

export {
	normalizeItems,
	withGeneratedId,
};
